import type { StorageInstance } from 'storage/domain/Storage'
import { getStorageInstance } from 'storage/services/getStorageInstance'

import { CACHE_KEY } from '../../constants/constants'

interface CartTotalItemsCacheProps {
	token?: string
	countryISO?: string
}

export const cartTotalItemsCache = ({
	token,
	countryISO,
}: CartTotalItemsCacheProps = {}): StorageInstance =>
	getStorageInstance({
		token,
		countryISO,
		cacheKey: CACHE_KEY,
		maxDiffTimestamp: 60000,
		isTokenCache: false,
		isCountryCache: false,
	})
